import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

const CustomTheme = definePreset(Material, {
  primitive: {
    blue: {
      200: '#EBF4FF',
      300: '#96D2FF',
      400: '#81B1EA',
      500: '#006BCB',
    },
    teal: {
      200: '#E6FBFC',
      400: '#64E7ED',
      500: '#007D83',
    },
    stone: {
      100: '#F6F6FF',
      200: '#D8D8F6',
      300: '#ADADC5',
      400: '#978897',
      500: '#494850',
    },
    green: {
      200: '#F2F9EB',
      400: '#7CBF36',
      500: '#51851B',
    },
    yellow: {
      200: '#FFF9E3',
      400: '#FFDB53',
      500: '#B27900',
    },
    red: {
      200: '#FFF1E9',
      400: '#FE6E26',
      450: '#BF460A',
      500: '#C33D24',
    },
  },
  semantic: {
    primary: {
      500: '{blue.500}',
      400: '{blue.400}',
      300: '{blue.300}',
      200: '{blue.200}',
    },
    secondary: {
      500: '{teal.500}',
      400: '{teal.400}',
      300: '{teal.300}',
      200: '{teal.200}',
    },
    grayscale: {
      500: '{stone.500}',
      400: '{stone.400}',
      300: '{stone.300}',
      200: '{stone.200}',
      100: '{stone.100}',
    },
    success: {
      500: '{green.500}',
      400: '{green.400}',
      200: '{green.200}',
    },
    danger: {
      200: '{red.200}',
      400: '{red.400}',
      500: '{red.500}',
    },
    info: {
      500: '{yellow.500}',
      400: '{yellow.400}',
      200: '{yellow.200}',
    },
    alert: {
      500: '{red.500}',
      400: '{red.400}',
      200: '{red.200}',
    },
  },

  components: {
    tabs: {
      tab: {
        color: '{grayscale.500}',
        hoverColor: '{primary.500}',
      },
    },
    button: {
      paddingX: '6rem',
      paddingY: '3rem',
      fontSize: '0.875rem',
      lg: {
        paddingX: '3.4rem',
      },
      sm: {
        paddingX: '1rem',
      },

      colorScheme: {
        root: {
          primary: {
            background: '{primary.500}',
          },
        },
      },
      primary: {
        hover: {
          background: '{primary.400}',
        },
      },
      borderRadius: '16px',
      color: '#fff',
    },
    panelmenu: {
      borderRadius: '0',
      item: {
        border: {
          radius: '0',
        },
        focus: {
          background: '{primary.200}',
          color: '{primary.500}',
        },
        hover: {
          background: '{primary.200}',
          color: '{primary.500}',
          borderRadius: '0',
        },
        active: {
          background: '{primary.200}',
          color: '{primary.500}',
        },
      },
      submenu: {},
    },
    toggleswitch: {
      colorScheme: {
        root: {
          height: '24px',
          width: '40px',
          gap: '3px',
          background: '{grayscale.200}',
          hover: {
            background: '{grayscale.200}',
          },
          checked: {
            background: '{primary.500}',
            hover: {
              background: '{primary.500}',
            },
          },
        },
        handle: {
          size: '18px',
          marginLeft: '3px',
          background: '{grayscale.100}',
          hover: {
            background: '{grayscale.100}',
          },
          checked: {
            marginRight: '-3px',
            background: '{grayscale.100}',
            hover: {
              background: '{grayscale.100}',
            },
          },
        },
      },
    },
    breadcrumb: {
      item: {
        color: '{primary.500}',
        hover: {
          color: '{primary.500}',
        },
      },
    },
    inputtext: {
      colorScheme: {
        root: {
          borderColor: '{grayscale.200}',
          hoverBorderColor: '{grayscale.200}',
          focusBorderColor: '{grayscale.200}',
          invalidBorderColor: '{alert.500}',
        },
      },
    },
    multiselect: {
      colorScheme: {
        root: {
          borderColor: '{grayscale.200}',
          hoverBorderColor: '{grayscale.200}',
          focusBorderColor: '{grayscale.200}',
          invalidBorderColor: '{alert.500}',
        },
      },
    },
    datatable: {
      colorScheme: {
        root: {
          paddingLeft: '2rem',
          paddingRight: '2rem',
        },
        headerCell: {
          borderColor: 'transparent',
          height: '36px',
        },
        bodyCell: {
          height: '48px',
        },
      },
    },
    paginator: {
      root: {
        borderRadius: '3px',
      },
    },
  },
});

export default CustomTheme;
